module.exports = __webpack_public_path__ + "assets/img/svg/common/phone.svg?v=1745861412107";